const getters = {
  profile: state => state.profile,
  type:state =>state.type,
  token: state => state.user && state.user.token,
  Logintoken: state => state.token,
  systemConfig:state =>state.systemConfig,
  signature:state =>state.signature
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js